import { useState } from 'react'
import Flatpickr from 'react-flatpickr'

export const ModernTimePicker = ({
  guid,
  format,
  style,
  defaultTime,
  update = () => {},
  readOnly,
  label = '',
  error,
  errorText,
}) => {
  const [updateCount, incrementCount] = useState(0)
  const invalidClass = error && error.length ? 'invalid' : ''

  const options = {
    enableTime: true,
    noCalendar: true,
    minuteIncrement: 1,
    dateFormat: format,
    altFormat: format,
    altInput: true,
    static: true,
    disableMobile: true,
    time_24hr: style === 1 ? false : true,
    enableSeconds: style === 2 || style === 3 ? true : false,
    altInputClass: `input-fields__input modern-time--alt-input ${invalidClass}`,
  }

  const handleUpdate = (selectedDates, dateStr, instance) => {
    const selectedTime = selectedDates[0]
    incrementCount(updateCount + 1)
    update(selectedTime)
  }

  const id = `hidden_timepicker_input-${guid}`

  return (
    <div className={`foundry--input-fields modern--input ${error ? 'foundry--field-error' : ''}`}>
      <Flatpickr
        id={id}
        key={`${guid}-${defaultTime}-${style}-${updateCount}`}
        className={`input-fields__input ${invalidClass}`}
        value={defaultTime}
        data-enable-time
        options={options}
        onOpen={(selectedDates, dateStr, instance) => {
          //Meh kinda method...flatpickr currently have no disable specific hours/minutes/seconds feature
          //So have to access the input's DOM to hide
          const disableHourDisplay = () => {
            instance.hourElement.parentElement.style.display = 'none'
            instance.hourElement.parentElement.nextSibling.style.display =
              'none'
          }
          //Disable + hide Hour display for MM:SS style
          style == 3 ? disableHourDisplay() : ''
        }}
        onClose={handleUpdate}
        disabled={readOnly}
      />
      {label && (
        <label htmlFor={id} className="input-fields__label">
          {label}
        </label>
      )}
      {error && (
        <div className="field-error--wrap">
          <i className="field-error--icon icon--solid foundry-icon icon--exclamation-triangle"></i>
          <span className="field-error--message">{errorText}</span>
        </div>
      )}
    </div>
  )
}
